module.exports = __webpack_public_path__ + "img/Doc09-20060073-001.6001cff9.jpg";